
export class AdminNote {
    appointment_id: string;
    message: string;
    username: string;
    created_at: string;
}